import { Pipe, PipeTransform } from '@angular/core';
import { I18nTranslator } from '../i18n/translate';
import { ARConsoleFormatType } from '../models/agrorendement-common-lists.model';

@Pipe({
  name: 'consoleFormatTypeLabel',
  standalone: true,
})
export class ConsoleFormatTypeLabelPipe implements PipeTransform {
  constructor(private i18nTranslator: I18nTranslator) {}

  transform(consoleFormatType: ARConsoleFormatType, args: any): any {
    if (consoleFormatType.label) {
      return consoleFormatType.label;
    }

    if (consoleFormatType.code === 'UNKNOWN') {
      return this.i18nTranslator.translate('ar.edit.vra.console.format.nonConnu');
    }

    // ne devrait pas arriver
    return '';
  }
}
